import { render, staticRenderFns } from "./userEvents.vue?vue&type=template&id=fd738afa"
import script from "./userEvents.vue?vue&type=script&lang=js"
export * from "./userEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports